export default __webpack_public_path__ + "static/media/6.d61d1615.jpg";